import { useState } from 'react'
import { I18n, Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { PopupContactUs } from '../../../../common/order/popup/popupContactUs'
import { valToPercent } from '../../../../helpers/value'

export const ContentColumnCell = (
  dataTable,
  rowId,
  colId,
  val,
  locale,
  rowIndex,
  isCurrentUserTypeId,
) => {
  const [isHovered, setIsHovered] = useState(false)
  const [isOpenPopupContactUs, setIsOpenPopupContactUs] = useState(false)

  // Actions
  const onOpenPopupContactUs = () => {
    setIsOpenPopupContactUs(true)
  }

  const onClosePopupContactUs = () => {
    setIsOpenPopupContactUs(false)
  }

  const isReportNameRow =
    dataTable?.find((item) => item.id === rowId).isReportNameRow || ''
  const isLastOffer =
    dataTable?.find((item) => item.id === rowId).isLastOffer || ''

  const handleContact = () => {
    onOpenPopupContactUs()
  }

  let rowValue = ''
  if (isReportNameRow) {
    rowValue = I18n.t('userManagement.packageList.SAVING_PER_REPORT')
  }

  if (isLastOffer && colId === 'Basic') {
    rowValue = (
      <Element
        elementName="span"
        style={{ color: '#2C73E8', fontStyle: 'italic', cursor: 'pointer' }}
        onClick={handleContact}
      >
        <Translate value="userManagement.packageList.CONTACT_US" />
      </Element>
    )
  }

  if (isLastOffer && colId !== 'Basic') {
    rowValue = ''
  }

  if (!isReportNameRow && !isLastOffer) {
    const percentageSaved = `${I18n.t(
      'userManagement.packageList.SAVE',
    )} ${valToPercent(val, locale, false, false, 0)}`
    rowValue = percentageSaved
  }

  const onMouseEnter = () => {
    setIsHovered(true)
  }

  const onMouseLeave = () => {
    setIsHovered(false)
  }

  const isEvenRow = rowIndex % 2 === 0
  const style = {
    backgroundColor: isHovered
      ? '#EDF5FE'
      : isEvenRow
      ? isCurrentUserTypeId
        ? '#EDF5FE'
        : '#F9F9F9'
      : '#FFFFFF',
  }

  return (
    <>
      <Element
        className={isReportNameRow ? 'fw600' : ''}
        style={isReportNameRow ? style : { ...style, color: '#3DA967' }}
        elementName="td"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {rowValue}
      </Element>
      <PopupContactUs
        isOpen={isOpenPopupContactUs}
        onClose={onClosePopupContactUs}
      />
    </>
  )
}
